import { DamperData, StartupBurnerData, StartupBurnerState, Tag } from "../models";

const iterateTags = (dampers: DamperData[], cb: Function): DamperData[] => {
  const newDampers = dampers.map((damper) => {
    const newTags = damper.tags.map((tag) => {
      if (!tag.tags) return cb(tag);

      return {
        ...tag,
        tags: tag.tags.map((localTag) => {
          return cb(localTag);
        }),
      };
    });

    return { ...damper, tags: newTags };
  });

  return newDampers;
};

const prepareTag = ({ tag_name, description, position, newPosition, override = false }: Tag): Tag => {
  const value = override ? newPosition ?? position : position;
  return { tag_name, description, position: value };
};

export const setTagProperty = (dampers: DamperData[], property: { [key: string]: string | boolean | number }): DamperData[] => {
  return iterateTags(dampers, (tag: Tag) => {
    return { ...tag, ...property };
  });
};

export const setTagValidity = (tag: Tag): Tag => {
  if (tag.position === undefined) return tag;

  if (tag.hasOwnProperty("newPosition")) {
    return { ...tag, valid: tag.newPosition! >= 0 && tag.newPosition! <= 100 };
  }

  return { ...tag, valid: tag.position === null ? false : tag.position >= 0 && tag.position <= 100 };
};

export const prepareStartupBurnerConfig = ({ tags, total_cooling_air }: StartupBurnerState): StartupBurnerData => {
  const newTags = tags.map((tag: Tag) => {
    return prepareTag(tag);
  });

  const { override, newPosition, value } = total_cooling_air;
  const totalCoolingAir = override ? newPosition ?? value : value;

  return { tags: newTags, total_cooling_air: totalCoolingAir };
};

export const prepareDampers = (dampers: DamperData[]): DamperData[] | undefined => {
  return iterateTags(dampers, prepareTag);
};

export const validateDamperData = (dampers: DamperData[]): DamperData[] => {
  return iterateTags(dampers, setTagValidity);
};

const validateTagPosition = (tag: Tag): boolean => {
  const { override, newPosition, position } = tag;

  const positionValue = override ? newPosition : position;

  if (positionValue === null || positionValue === undefined || (tag.hasOwnProperty("valid") && !tag.valid)) {
    console.log(tag.tag_name);
    return false;
  }

  return true;
};

export const validateStartupBurnerConfig = (tags: Tag[]): boolean => {
  for (const tag of tags) {
    if (!validateTagPosition(tag)) {
      return false;
    }
  }

  return true;
};

export const damperValuesAreValid = (dampers: DamperData[]): boolean => {
  for (const damper of dampers) {
    for (const tag of damper.tags) {

      if (tag.position !== undefined && !validateTagPosition(tag)) {
        return false;
      }

      if (tag.tags) {
        for (const localTag of tag.tags) {
          if (localTag.position !== undefined && !localTag.valid) {
            console.log(localTag.tag_name);
            return false;
          }
        }
      }
    }
  }

  return true;
};
